module.exports = __webpack_public_path__ + "img/upload_fill.f8fe3c0b.svg";